// pages/ManagerLoanList.js

const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

const money = (val) =>
  `Rs. ${Number(val || 0).toLocaleString('en-IN')}`;

const ManagerLoanList = ({ loans = [], loading, error }) => {
  return (
    <div className="twgold_manager_card">
      <h3>Active Loan Ledger</h3>

      {loading && <p>Loading loans...</p>}

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {!loading && !error && (
        <table className="twgold_manager_table">
          <thead>
            <tr>
              <th>Loan No</th>
              <th>Customer</th>
              <th>Principal</th>
              <th>Next Due</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {loans.length === 0 ? (
              <tr>
                <td colSpan="5">No loans found</td>
              </tr>
            ) : (
              loans.map((loan) => (
                <tr key={loan.loanAccountNumber}>
                  <td>{loan.loanAccountNumber}</td>
                  <td>{loan.customerName}</td>
                  <td>{money(loan.principal)}</td>
                  <td>{formatDate(loan.nextDueDate)}</td>
                  <td>
                    <span
                      className={
                        loan.status === 'overdue'
                          ? 'status_overdue'
                          : loan.status === 'closed'
                          ? 'status_closed'
                          : 'status_active'
                      }
                    >
                      {loan.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ManagerLoanList;